import * as ng from 'angular';
import {PreviewService} from '../../../../../services/preview.service';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {FileService} from '../../../../../services/file.service';
import {StoreService} from '../../../../../services/store.service';
import {AlertService} from '../../../../../services/ui/alert.service';
import {DocumentStatus} from '../../../../../commons/document-status';
import {TableHeaderItem} from '../../../../../commons/components/table-component/domain/table-header-item';
import {IFatturaAttivaItem} from '../../../../../commons/interfaces/invoices/attive';
import {IResultResponse} from '../../../../../commons/interfaces/IResultResponse';

interface IFilter {
  user: string;
  _id: string;
  status: string;
  number: string;
  idSdi: string;
  sendingId: string;
  object: string;
  dataFrom: string;
  dataTo: string;
  cessionary: string;
  fiscalId: string;
  fiscalCode: string;
  receiverCode: string;
  reference: string;
  onlyLastVersion: true;
  invoice_type: string;
  pageNumber: number;
  pageSize: number;
  option?: string;
}

interface ISettings {
  filter: IFilter;
  sortField: string;
  sortDirection: number;
  pageSizes: number[];
  itemsCount?: number;
}

export const PAVisualizzaStatoFattureComponent = {
  template: require('./pa-visualizza-stato-fatture.html'),
  controller: class PAVisualizzaStatoFattureController {

    static $inject: string[] = [
      '$scope',
      '$rootScope',
      '$state',
      'ArchiSmallServices',
      'AlertService',
      'FileService',
      'StoreService',
      '$sce',
      '$uibModal',
      '$stateParams',
      'PreviewService'
    ];

    private headerColumns: Array<TableHeaderItem>;

    constructor(
      private $scope: {
        settings: ISettings,
        items: IFatturaAttivaItem[],
        moreDataToLoad: boolean,
        statusList: string[],
        selectedItem: IFatturaAttivaItem,
        selectedItems: string[],
        selectedFatture: IFatturaAttivaItem[],
        [key: string]: any
      },
      private $rootScope: any,
      private $state: ng.ui.IStateService,
      private archiSmallServices: ArchiSmallServices,
      private alertService: AlertService,
      private fileService: FileService,
      private storeService: StoreService,
      private $sce: ng.ISCEService,
      private $uibModal: ng.ui.bootstrap.IModalService,
      private $stateParams: ng.ui.IStateParamsService,
      private previewService: PreviewService
    ) {
      $scope.pageHeader = 'Fatture Trasmesse PA';
      $scope.selectedItems = [];
      $scope.items = [];
      $scope.selectedFatture = [];
      $scope.moreDataToLoad = true;
      let processingRequest = false;

      this.headerColumns = [
        {key: 'status', label: 'Stato', ratio: '15', isSortable: true},
        {key: 'number', label: 'N. fattura', ratio: '11', isSortable: true},
        {key: 'idSdi', label: 'Id Sdi', ratio: '8', isSortable: true},
        {key: 'sendingId', label: 'Progr. invio', ratio: '6', isSortable: true},
        {key: 'object', label: 'Oggetto', ratio: '10', isSortable: true},
        {key: 'date', label: 'Data', ratio: '11', isSortable: true},
        {key: 'cessionary', label: 'PA Destinataria', ratio: '15', isSortable: true},
        {key: 'fiscalId', label: 'P.Iva PA', ratio: '11', isSortable: true},
        {key: 'fiscalCode', label: 'Codice Fiscale PA', ratio: '12', isSortable: true},
        {key: 'receiverCode', label: 'Codice PA', ratio: '11', isSortable: true},
        {key: 'reference', label: 'Riferimento', ratio: '6', isSortable: true},
        {key: 'action', label: 'Azioni', ratio: '13', isSortable: false}
      ];

      let trusted = {};

      $scope.statoDescription = (status, number, erroreMessageDetails) => {
        switch (status) {
          case 'Scartata':
            return trusted['scartata' + number] || (trusted['scartata' + number] = $sce.trustAsHtml('<span><b>Notifica di scarto</b></span><br/><span>Abbiamo ricevuto una notifica di scarto dal Sistema di Interscambio per la fattura numero <b>' + number + '</b>. </span><br/><span> Verifica il motivo dello scarto e correggi l’errore; <br/><b>Ricorda che puoi modificare la fattura e reinviarla selezionando \'Reinvia Fattura\'.</b></span>'));
          case 'Trasmessa allo SdI':
            return trusted['trasmessa' + number] || (trusted['trasmessa' + number] = $sce.trustAsHtml('<span><b>Trasmessa allo SdI</b></span>'));
          case 'Generata':
            return trusted['generata' + number] || (trusted['generata' + number] = $sce.trustAsHtml('<span><b>Generata</b></span>'));
          case 'Non ancora consegnata':
            return trusted['non-consegnata' + number] || (trusted['non-consegnata' + number] = $sce.trustAsHtml('<span><b>Notifica mancata consegna</b></span><br/><span> Abbiamo ricevuto una notifica di mancata consegna per la tua fattura numero <b>' + number + '</b>. </span><br/><span>La notifica di mancata consegna è inviata al trasmittente del file FatturaPA quando il Sistema di Interscambio non riesce a consegnare il file alla Pubblica Amministrazione destinataria.<br/>Il Sistema di Interscambio provvede a contattare la PA destinataria per segnalare il problema e per invitarla alla sua risoluzione.<br/>Nei successivi 10 giorni il Sistema di Interscambio proverà nuovamente l\'inoltro del file  FatturaPA all\'Amministrazione destinataria.<br/>Se la consegna riesce, il Sistema di Interscambio invia al mittente una ricevuta di consegna, altrimenti, trascorsi 10 giorni dall\' invio della notifica di mancata consegna, invia al mittente un’attestazione di avvenuta trasmissione della fattura con impossibilità di recapito. Attendi riscontro dal Sistema di Interscambio</span>'));
          case 'Consegnata':
            return trusted['consegnata' + number] || (trusted['consegnata' + number] = $sce.trustAsHtml('<span><b>Ricevuta di consegna:</b></span><br/><span>La tua fattura numero <b>' + number + '</b> è stata correttamente consegnata alla PA destinataria. Attendi l’esito dalla PA.</span>'));
          case 'Accettata':
            return trusted['accettata' + number] || (trusted['accettata' + number] = $sce.trustAsHtml('<span><b>Accettata</b></span><br/>'));
          case 'Rifiutata':
            return trusted['rifiutata' + number] || (trusted['rifiutata' + number] = $sce.trustAsHtml('<span><b>Notifica di scarto esito cessionario committente:</b></span><br/><span> Abbiamo ricevuto una notifica di scarto esito per la tua fattura numero <b>' + number + '</b>. </span><br/><span>La notifica di scarto esito è inviata dal Sistema di Interscambio per segnalare una non ammissibilità o non conformità della fattura, rilevata dalla PA destinataria a seguito della notifica di accettazione o rifiuto.</span><br/><span><b>Nel caso in cui la Fattura è stata scartata dalla PA entro 15 giorni potrai semplicemente correggere la fattura e re-inoltrarla, selezionando \'Reinvia Fattura\'.</b><br/><span>Ricorda che la fattura è da considerarsi regolarmente emessa, per cui verifica con la PA il motivo dello scarto e se la fattura è stata registrata contabilmente dalla Pubblica amministrazione. In tal caso dovrai emettere nota di credito e nuova fattura.</span>'));
          case 'Decorsi i termini':
            return trusted['termini' + number] || (trusted['termini' + number] = $sce.trustAsHtml('<span><b>Notifica di decorrenza termini</b></span><br/><span> Abbiamo ricevuto una notifica di decorrenza termini per la tua fattura numero <b>' + number + '</b>. </span><br/><span>La notifica di decorrenza termini è un messaggio che il SdI invia sia al trasmittente sia al destinatario nel caso in cui non abbia ricevuto notifica di esito dalla PA entro il termine di 15 giorni dalla data di ricevuta di consegna.</span><br/><span>Con questa notifica il SdI comunica al destinatario l’impossibilità di inviare, da quel momento in poi, notifica di esito committente e al trasmittente l’impossibilità di ricevere notifica di esito.</span><br/><span>In questo caso la fattura non è da considerarsi né accettata né rifiutata, verifica con la PA destinataria lo stato fattura, in quanto alcune PA considerano la notifica decorrenza termini come un tacito assenso di accettazione della fattura.<br/> Ricorda che la fattura è da considerarsi emessa</span>'));
          case 'Non recapitabile':
            return trusted['non-recapitabile' + number] || (trusted['non-recapitabile' + number] = $sce.trustAsHtml('<span><b>Attestazione di avvenuta trasmissione della fattura con impossibilità di recapito</b></span><br/><span> Abbiamo ricevuto una <b>attestazione di avvenuta trasmissione della fattura con impossibilità di recapito</b> per la tua fattura numero <b>' + number + '</b>. </span><br/><span>Questa notifica viene consegnata trascorsi 10 giorni dall\'invio della notifica di mancata consegna per cause non imputabili al trasmittente, ricorda che la fattura è da considerarsi emessa per cui la fattura non potrà essere reinviata al SDI. Per questo motivo verifica con la PA destinataria i contatti di trasmissione e ricorda di stornare la fattura dalla tua contabilità. A seguito di queste operazioni potrai trasmettere una nuova fattura</span>'));
          case 'Presa in carico':
            return trusted['presa' + number] || (trusted['presa' + number] = $sce.trustAsHtml('<span><b>Presa in carico</b></span><br/><span>La tua fattura numero <b>' + number + '</b> è stata presa in carico e a breve verrà inviata allo SDI.</span>'));
          case 'ERRORE TRASMISSIONE':
            return trusted['errore' + number] || (trusted['errore' + number] = $sce.trustAsHtml('<span><b>ERRORE TRASMISSIONE</b></span><br/><span>Verificare il file xml. Aprire un ticket <a href="mailto:helparchismall@smeup.com?subject=Richiesta assistenza"> Contatta il supporto tecnico</a>.</span>' + (erroreMessageDetails ? ('<br/><strong>Errore:</strong><br/>' + erroreMessageDetails) : '')));
          case 'Rielaborata':
            return trusted['rielaborata' + number] || (trusted['rielaborata' + number] = $sce.trustAsHtml('<span><b>Rielaborata</b></span>'));
          case 'SCARTATA DA ARCHISMALL':
            return trusted['errorearch' + number] || (trusted['errorearch' + number] = $sce.trustAsHtml('<span><b>SCARTATA DA ARCHISMALL</b></span>' + (erroreMessageDetails ? ('<br/><strong>Errore:</strong><br/>' + erroreMessageDetails) : '')));
        }
      };

      $scope.documentStatuses = [
        {name: '', class: ''},
        {name: 'Versato', class: 'label-primary'},
        {name: 'Conservato', class: 'label-success'},
        {name: 'Presa in carico', class: 'label-warning'},
        {name: 'Negativo', class: 'label-danger'},
        {name: 'Da Verificare', class: 'label-info'},
        {name: 'ERRORE TRASMISSIONE', class: 'label-danger'},
        {name: 'SCARTATA DA ARCHISMALL', class: 'label-danger'}
      ];

      $scope.openNotificationsModal = (size, item) => {
        $uibModal.open({
          animation: true,
          component: 'notificationsModalComponent',
          size: size,
          windowClass: 'center-modal',
          resolve: {
            invoice: () => {
              return item;
            },
            stato: () => {
              return $scope.statoDescription;
            }
          }
        });
      };

      $scope.openVisualizzaFilterModal = (size) => {
        let VisualizzaFilterModalInstance = $uibModal.open({
          animation: true,
          component: 'visualizzaPAFilterComponent',
          size: size,
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            filter: () => {
              return $scope.settings;
            },
            selected: () => {
              return $scope.selectedItems;
            }
          }
        });
        VisualizzaFilterModalInstance.result.then((settings) => {
          if (settings !== undefined) {
            $scope.settings = settings;
            $scope.settings.filter.pageNumber = 1;
            $scope.getItems();
          }
        }, (error) => {
          // ?
        });
      };

      $scope.getItemById = (id) => {
        for (let item in $scope.items) {
          if ($scope.items[item]._id === id) {
            $scope.selectedItem = $scope.items[item];
          }
        }
      };

      $scope.clearSelection = () => {
        $scope.selectedItems = [];
        for (let i = 0; i < $scope.items.length; i++) {
          $scope.items[i].isSelected = false;
        }
        $scope.selectAllValue = false;
      };

      $scope.settings = {
        'filter': {
          'user': this.storeService.getCurrentUser().sub,
          '_id': '',
          'status': '',
          'number': decodeURIComponent($stateParams.numeroFattura),
          'idSdi': '',
          'sendingId': '',
          'object': '',
          'dataFrom': '',
          'dataTo': '',
          'cessionary': '',
          'fiscalId': '',
          'fiscalCode': '',
          'receiverCode': '',
          'reference': '',
          'onlyLastVersion': true,
          'invoice_type': 'PA',
          'pageNumber': 1,
          'pageSize': 100
        },
        'sortField': '_id',
        'sortDirection': -1,
        'pageSizes': [20, 50, 100]
      };

      $scope.getItems = () => {
        if (processingRequest) {
          return;
        }

        processingRequest = true;
        this.archiSmallServices.getFatturazioneDocuments($scope.settings.filter, $scope.settings.sortField, $scope.settings.sortDirection)
          .then((response) => {
            const res = JSON.parse(JSON.stringify(response)) as IResultResponse<IFatturaAttivaItem>;
            if (res.Result === 1) {
              $scope.settings.itemsCount = res.itemsCount;

              $scope.items = res.resultList;

              $scope.moreDataToLoad = $scope.items.length < $scope.settings.itemsCount;
            }

            $scope.selectedFatture = [];
            processingRequest = false;
          }, (error) => {
            this.alertService.alert('error', error);
            processingRequest = false;
          });
      };

      $scope.checkIfSelectedDocumentStatusIsOk = (selectedItems) => {
        for (let i = 0; i < selectedItems.length; i++) {
          for (let j = 0; j < $scope.items.length; j++) {
            if ($scope.items[j]._id === selectedItems[i]) {
              if ($scope.items[j].status === $scope.documentStatuses[DocumentStatus.PresoInCarico].name) {
                this.alertService.alert('warning', 'La Fattura con stato \'Presa in carico\' non è disponibile per il download.');
                return true;
              }
            }
          }
        }
      };

      $scope.getItems();

      $scope.clearFilter = () => {
        $scope.settings.filter.status = '';
        $scope.settings.filter.number = '';
        $scope.settings.filter.idSdi = '';
        $scope.settings.filter.dataFrom = '';
        $scope.settings.filter.dataTo = '';
        $scope.settings.filter.sendingId = '';
        $scope.settings.filter.object = '';
        $scope.settings.filter.cessionary = '';
        $scope.settings.filter.fiscalId = '';
        $scope.settings.filter.fiscalCode = '';
        $scope.settings.filter.receiverCode = '';
        $scope.settings.filter.reference = '';
        $scope.settings.filter.onlyLastVersion = true;
        $scope.settings.filter.sendingId = '';
        $scope.settings.filter.pageNumber = 1;
        $scope.settings.filter.option = '';

        $scope.items = [];
        $scope.moreDataToLoad = true;
        $scope.getItems();
      };

      $scope.WorkerFatturazioneGeneratePackageModal = (PackageType, docId) => {
        if (docId !== undefined) {
          // one document
          // if is requested DIP download of ONLY ONE doc
          // we verify if the DIP is set
          // and we download it in case of true

          let indexes = $.map($scope.items, (obj, index) => {
            if (obj._id === docId) {
              return index;
            }
          });
          if (indexes.length !== 1) {
            return;
          }

          if ($scope.items[indexes[0]].DIP.Status === 2) {
            this.fileService.downloadFile($scope.items[indexes[0]].DIP.FilePath);
            return;
          } else {
            if ($scope.items[indexes[0]].DIP.Status === 1) {
              return;
            }
            $scope.items[indexes[0]].DIP.Status = 1;
            this.archiSmallServices.updateConservazioneDIPStatus($scope.items[indexes[0]])
              .then((response: any) => {
                $scope.getItems();
                $uibModal.open({
                  animation: true,
                  component: 'workerFatturazioneGeneratePackagePAModalComponent',
                  windowClass: 'center-modal',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    settings: {
                      'PackageType': PackageType,
                      'DocumentIds': [docId],
                      'user': this.storeService.getCurrentUser().sub
                    }
                  }
                });
              }, (error) => {
                this.alertService.alert('error', error);
                processingRequest = false;
              });
          }
        } else { // multiple documents

          if ($scope.selectedItems.length === 0) {
            return;
          }

          let packageType: any;

          switch (PackageType) {
            case 'FatturaPA-PDF':
              packageType = 'PDF';
              break;
            case 'FatturaPA-XML':
              packageType = 'XML';
              break;
          }

          if ($scope.checkIfSelectedDocumentStatusIsOk($scope.selectedItems)) {
            return;
          }
          $uibModal.open({
            animation: true,
            component: 'workerFatturazioneGeneratePackagePAModalComponent',
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              settings: {
                'PackageType': PackageType,
                'DocumentIds': $scope.selectedItems,
                'user': this.storeService.getCurrentUser().sub
              }
            }
          });
        }
      };

      $scope.contextMenuItemTitle = '<span><strong class=\'centered\'>' + $scope.selectedItems.length + ' items selected</strong></span>';
      $scope.contextMenuOptions = (itemDocument) => {
        $scope.menuOptionsSingle[0][0] = '<span><strong>Fattura ' + itemDocument.number + '</strong></span>';
        if (itemDocument.hasAttachment === false) {
          $scope.menuOptionsSingle[10][0] = '<i class=\'icon-icon_file link-disabled\'></i> <span class="link-disabled">Scarica Allegato</span>';
        } else {
          $scope.menuOptionsSingle[10][0] = '<i class=\'icon-icon_file\'></i> <span class="">Scarica Allegato</span>';
        }
        return $scope.menuOptionsSingle;
      };

      $scope.contextMenuItemPDF = '<i class=\'icon-icon_file_pdf\'></i> <span>Scarica File PDF</span>';
      $scope.contextMenuItemXML = '<i class=\'icon-icon_file_xml\'></i> <span>Scarica File XML</span>';
      $scope.contextMenuItemNotifications = '<i class=\'icon-icon_bell\'></i> <span>Notifiche</span>';
      $scope.contextMenuItemPreview = '<i class=\'fa fa-eye\'></i> <span>Anteprima</span>';
      $scope.contextMenuItemAllegato = '<i class=\'icon-icon_file\'></i> <span class="">Scarica Allegato</span>';

      $scope.menuOptionsSingle = [
        [$scope.contextMenuItemTitle, ($itemScope) => {
          //
        }],
        null,
        [$scope.contextMenuItemPDF, ($itemScope) => {
          this.fileService.downloadFile($itemScope.item.filePathPDF);
        }],
        null,
        [$scope.contextMenuItemXML, ($itemScope) => {
          archiSmallServices.downloadFatturaXml($scope.selectedFatture[0]._id, $scope.selectedFatture[0].filePathXML.split('/').pop());
        }],
        null,
        [$scope.contextMenuItemNotifications, ($itemScope) => {
          $scope.openNotificationsModal('md', $itemScope.item);
        }],
        null,
        [$scope.contextMenuItemPreview, ($itemScope) => {
          this.previewService.showPreview($itemScope.item, this.previewModal);
        }],
        null,
        [$scope.contextMenuItemAllegato, ($itemScope) => {
          this.fileService.downloadAttachment($itemScope.item);
        }]
      ];

      $scope.downloadFatture = (xml: boolean) => {
        if ($scope.selectedFatture.length === 1) {
          if (xml) {
            archiSmallServices.downloadFatturaXml($scope.selectedFatture[0]._id, $scope.selectedFatture[0].filePathXML.split('/').pop());
          } else {
            this.fileService.downloadFile(xml ? $scope.selectedFatture[0].filePathXML : $scope.selectedFatture[0].filePathPDF);
          }
        } else {

          if (xml) {
            // console.log('gestione xml');

            // gestisci download xml
            $uibModal.open({
              animation: true,
              component: 'workerFatturazioneDownloadFatturePRModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                settings: {
                  type: 'paa_xml',
                  fatture: $scope.selectedFatture.filter(item =>
                    !(item.status === $scope.documentStatuses[$rootScope.DocumentStatus.PresoInCarico].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ErroreTrasmissione].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ScartataArchismall].name)),
                  user: this.storeService.getCurrentUser().sub
                }
              }
            });
          } else {
            // console.log('gestione pdf');

            // gestisci download pdf
            $uibModal.open({
              animation: true,
              component: 'workerFatturazioneDownloadFatturePRModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                settings: {
                  type: 'paa_pdf',
                  fatture: $scope.selectedFatture.filter(item =>
                    !(item.status === $scope.documentStatuses[$rootScope.DocumentStatus.PresoInCarico].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ErroreTrasmissione].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ScartataArchismall].name)),
                  user: this.storeService.getCurrentUser().sub
                }
              }
            });
          }
        }
      };

      $scope.addOrRemoveSelectedItem = (item: IFatturaAttivaItem) => {
        $scope.selectedFatture = $scope.selectedFatture.filter(item => item.isSelected);
        if (item.isSelected && !$scope.selectedFatture.includes(item)) {
          $scope.selectedFatture = $scope.selectedFatture.concat(item);
        }
        // console.log($scope.disableDownloadFile(), $scope.disableNotifications(), $scope.selectedFatture.length === 1);
        // $scope.selectedItem = item.isSelected ? item : undefined;
      };

      $scope.disableDownloadFile = () => {
        return $scope.selectedFatture.every(item =>
          item.status === $scope.documentStatuses[$rootScope.DocumentStatus.PresoInCarico].name
          || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ErroreTrasmissione].name
          || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ScartataArchismall].name);
      };

      $scope.disableNotifications = () => {
        return ($scope.selectedFatture.length === 1 ? $scope.disableDownloadFile() : true);
      };
    }

    private openExportModal = (size: string) => {
      this.$uibModal.open({
        animation: true,
        component: 'exportComponent',
        size: size,
        windowClass: 'center-modal',
        resolve: {
          packageTypePrefix: () => {
            return 'FatturaPA';
          },
          user: () => {
            return this.storeService.getCurrentUser().sub;
          }
        }
      });
    }

    private rectifyInvoice = (item: any) => {
      switch (item.uploadType) {
        case 1:
          this.$state.go('home.pa-componi-fattura-semplice', {xmlpath: item.filePath});
          break;
        case 2:
          this.$state.go('home.pa-componi-fattura', {xmlpath: item.filePath});
          break;
        case 3:
          this.$state.go('home.pa-carica-fattura');
          break;
      }
    }

    generateNc(item: IFatturaAttivaItem) {
      switch (item.uploadType) {
        case 1:
          this.$state.go('home.componi-fattura-pr-semplice', {xmlpath: item.filePath, requestNotaCredito: true});
          break;
        case 2:
          this.$state.go('home.pr-componi-fattura-avanzata', {xmlpath: item.filePath, requestNotaCredito: true});
          break;
        case 3:
          this.$state.go('home.pr-carica-fattura');
          break;
      }
    }

    private openRiferimentoModal = (size: string, referenceValue: any, option: any, event: Event) => {
      let RiferimentoModal = this.$uibModal.open({
        animation: true,
        component: 'riferimentoPAModalComponent',
        size: size,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'center-modal',
        resolve: {
          referenceValue: () => {
            return referenceValue;
          },
          option: () => {
            return option;
          }
        }
      });
      event.stopPropagation();
      RiferimentoModal.result.then(() => {
        // ??
      }, () => {
        // ??
      });
    }

    private previewModal = (item: any, type: any) => {
      this.$uibModal.open({
        animation: true,
        component: 'previewModalComponent',
        controllerAs: 'vm',
        size: 'preview',
        resolve: {
          path: () => {
            return item.filePathPDF;
          },
          type: () => {
            return type;
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-visualizza-stato-fatture/pa-visualizza-stato-fatture.ts